<div clas="baseline-container" [formGroup]="grp">
  <div class="baseline-required">
    <mat-slide-toggle fxFlex formControlName="isRequired" color="primary">
      <label class="form-label">Baseline Required</label>
    </mat-slide-toggle>
  </div>
  @if (grp.value.isRequired) {
    <div class="baseline-content">
      <mat-form-field fxFlex>
        <mat-label>Below threshold</mat-label>
        <input matInput type="number" placeholder="" formControlName="belowThresholdMultiplier" maxlength="6"
          autocomplete="off" step="1">
      </mat-form-field>
      <mat-form-field fxFlex>
        <mat-label>Above threshold</mat-label>
        <input matInput type="number" placeholder="" formControlName="aboveThresholdMultiplier" maxlength="6"
          autocomplete="off" step="1">
      </mat-form-field>
    </div>
  }
</div>